module.exports = __webpack_public_path__ + "img/pied-piper-alt.4017a5d2.svg";